// Standardized colors matching existing codebase patterns
export const DIALOG_COLORS = {
  confirm: {
    success: '#4caf50',      // Green - for positive actions
    danger: '#d32f2f',       // Red - for destructive actions
    primary: '#1976d2',      // Blue - for neutral confirmations
    warning: '#ed6c02',      // Orange - for warnings
  },
  cancel: {
    default: '#757575',      // Gray - standard cancel (Professional)
    neutral: '#9e9e9e',      // Gray - secondary cancel
  }
} as const;

// Standardized messages
export const DIALOG_MESSAGES = {
  delete: {
    title: 'Are you sure?',
    text: (itemName: string, itemType?: string) =>
      `Do you want to delete this ${itemType || 'item'}${itemName ? `: ${itemName}` : ''}?`,
    confirmText: 'Yes, Delete',
    cancelText: 'Cancel',
    successTitle: 'Deleted!',
    successText: (itemType?: string) =>
      `The ${itemType || 'item'} has been deleted successfully.`,
    errorTitle: 'Delete Failed',
    errorText: 'Something went wrong while deleting. Please try again.',
  },
  deactivate: {
    title: 'Are you sure?',
    text: (itemName: string, itemType?: string) =>
      `Do you want to deactivate this ${itemType || 'item'}${itemName ? `: ${itemName}` : ''}?`,
    confirmText: 'Yes, Deactivate',
    cancelText: 'Cancel',
    successTitle: 'Deactivated!',
    successText: (itemType?: string) =>
      `The ${itemType || 'item'} has been deactivated successfully.`,
    errorTitle: 'Deactivate Failed',
    errorText: 'Something went wrong while deactivating. Please try again.',
  },
  save: {
    successTitle: 'Saved!',
    successText: 'Your changes have been saved successfully.',
    errorTitle: 'Save Failed',
    errorText: 'Failed to save changes. Please try again.',
  },
  submit: {
    successTitle: 'Submitted!',
    successText: 'Your submission was successful.',
    errorTitle: 'Submission Failed',
    errorText: 'Failed to submit. Please try again.',
  },
  validation: {
    title: 'Validation Error',
    text: 'Please correct the errors before proceeding.',
  }
} as const;

// Default timer for auto-close notifications
export const DEFAULT_TIMER = 1500;
